/** Canonical time signatures for tune metadata (admin, page editor, imports). */
export const ALLOWED_TIME_SIGNATURES = ['2/4', '3/4', '4/4', '6/8', '9/8', '12/8'];

const ALIASES = {
  'cut time': '2/4',
  'cut-time': '2/4',
  '2/2': '2/4',
  'c': '4/4',
  'common time': '4/4',
  '3/8': '6/8',
};

/**
 * Normalize free-text / legacy values to an allowed time signature, or '' if unknown.
 */
export function normalizeTimeSignature(raw) {
  if (raw == null) return '';
  const s = String(raw).trim();
  if (!s) return '';
  const lower = s.toLowerCase();
  if (ALIASES[lower]) return ALIASES[lower];
  const m = s.match(/^(\d+)\s*\/\s*(\d+)$/);
  if (m) {
    const normalized = `${m[1]}/${m[2]}`;
    if (ALLOWED_TIME_SIGNATURES.includes(normalized)) return normalized;
    if (normalized === '3/8') return '6/8';
    if (normalized === '2/2') return '2/4';
  }
  if (ALLOWED_TIME_SIGNATURES.includes(s)) return s;
  return '';
}

export function isAllowedTimeSignature(raw) {
  return ALLOWED_TIME_SIGNATURES.includes(normalizeTimeSignature(raw));
}
